import { FC } from 'react';

export interface AmplienceSpacerProps {
  spacerHeight: string;
  spacerHeightMobile: string;
  overrideHeight?: number;
  overrideHeightMobile?: number;
  goldLine?: boolean;
}

const AmplienceSpacer: FC<AmplienceSpacerProps> = ({
  spacerHeight,
  spacerHeightMobile,
  overrideHeight,
  overrideHeightMobile,
  goldLine,
}) => {
  return (
    <>
      <div
        data-testid="spacer-component-desktop"
        style={{
          height: `${overrideHeight || spacerHeight}px`,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {goldLine && <div className="hidden h-px w-full bg-primary-gold lg:flex" />}
      </div>

      <div
        data-testid="spacer-component-mobile"
        style={{
          height: `${overrideHeightMobile || spacerHeightMobile}px`,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {goldLine && <div className="flex h-px w-full bg-primary-gold lg:hidden" />}
      </div>
    </>
  );
};
export default AmplienceSpacer;
